export default "__VITE_ASSET__BxwXVN8C__"